"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wait = void 0;
const react_1 = __importStar(require("react"));
const options_1 = require("../basics/options");
const widget_1 = require("../basics/widget");
const Wait = (props) => {
    const [timer, setTimer] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        /** Note: new_props will keep getting ignored if there is a timer already running */
        if (timer === undefined) {
            setTimer(window.setTimeout(() => {
                setTimer(undefined);
                props.onDone(props.input());
            }, props.milliseconds));
        }
    }, [timer, props]);
    (0, react_1.useEffect)(() => {
        return () => window.clearTimeout(timer);
    }, []);
    return timer === undefined ? react_1.default.createElement(react_1.default.Fragment, null) : react_1.default.createElement(react_1.default.Fragment, { key: (0, options_1.option)('key', props.options) });
};
/**
 * `wait` builds a widget that waits a given number of `milliseconds` and then yields the lazy inputted value of type `io`.
 *
 *  Only after the given time passes, the lazy input is **computed** and passed to the output.
 *
 *
 * @typeparam io Both the input type and the output type of this IOwidget.
 * @param milliseconds The time to wait until yielding the output
 * @param options general widget options
 */
const wait = (milliseconds, options) => (input) => (0, widget_1.fromJSX)((onDone) => react_1.default.createElement(Wait, { onDone: onDone, input: input, milliseconds: milliseconds, options: options }));
exports.wait = wait;
